import { userServerAddress } from '../../common/MetaSetting';
import { authGet, authPost, authPut, authDelete } from '../../utils/authFetch';
import { ApiResponse, UserDetail, SecurityUserDetail } from '../types';

class ApiClient {
  private baseURL: string;

  constructor(baseURL: string) {
    this.baseURL = baseURL;
  }

  async get<T>(endpoint: string): Promise<ApiResponse<T>> {
    const response = await authGet(`${this.baseURL}${endpoint}`);
    return response.json();
  }

  async post<T>(endpoint: string, data?: any): Promise<ApiResponse<T>> {
    const response = await authPost(`${this.baseURL}${endpoint}`, {
      body: data
    });
    return response.json();
  }

  async put<T>(endpoint: string, data?: any): Promise<ApiResponse<T>> {
    const response = await authPut(`${this.baseURL}${endpoint}`, {
      body: data
    });
    return response.json();
  }

  async delete<T>(endpoint: string): Promise<ApiResponse<T>> {
    const response = await authDelete(`${this.baseURL}${endpoint}`);
    return response.json();
  }
}

// 创建API客户端实例（通过BFF代理访问，自动携带认证信息）
export const apiClient = new ApiClient(userServerAddress);

// 用户相关API
export const userAPI = {
  // 获取当前用户信息（来自MongoDB）
  getCurrentUser: () => apiClient.get('/user'),
  getUserDetail: () => apiClient.get<UserDetail>('/user/detail'),

  // 获取用户安全信息（来自MySQL）
  getUserSecureInfo: () => apiClient.get<SecurityUserDetail>('/security/user/detail'),

  // 更新用户详情
  updateUserDetail: (data: { username: string; nickName?: string; avatarPath?: string }) =>
    apiClient.put<UserDetail>('/user/detail', data),

  // 更新用户安全信息
  updateUserSecureInfo: (data: { email?: string; firstName?: string; lastName?: string }) =>
    apiClient.put<SecurityUserDetail>('/security/user/detail', data),

  // 重置密码
  resetPassword: (data: { password: string; confirmPassword: string }) =>
    apiClient.put('/security/pwd/reset', data),

  // 获取用户列表
  getUsers: () => apiClient.get('/security/users'),
};

// 认证相关API（通过BFF处理）
export const authAPI = {
  // 登录（通过BFF OAuth2流程，不直接调用）
  // 登出（通过BFF AuthService处理）
};
